import { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import RegionNodeChart, { Level2RegionChart } from "./RegionNodeChart";
import RegionGrid from "./RegionGrid";

export default function MainGridRegions() {
  const [selectedRegionId, setSelectedRegionId] = useState(null);

  const handleRegionSelect = (regionId) => {
    setSelectedRegionId(regionId);
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: { sm: "100%", md: "1700px" },
        minHeight: "100vh",
        margin: "0 auto",
      }}
    >
      <Grid container spacing={2} columns={12}>
        {/* Level 2 Region Chart - Level 2'lerin içindeki Level 3 sayıları */}
        <Grid size={{ xs: 12, lg: 3 }}>
          <Stack spacing={2}>
            <Level2RegionChart
              onRegionSelect={handleRegionSelect}
              selectedRegionId={selectedRegionId}
            />
            <RegionNodeChart selectedParentRegionId={selectedRegionId} />
          </Stack>
        </Grid>
        {/* Region Grid - Tüm bölgeler tablosu */}
        <Grid size={{ xs: 12, lg: 9 }}>
          <RegionGrid onRegionSelect={handleRegionSelect} />
        </Grid>
      </Grid>
    </Box>
  );
}
